// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-3bf9c775&scoped=true!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/editable/Editable.vue
// module id = 436
// module chunks = 0